import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';

import {
  BankItem,
  BankResponse,
  BankActionArgument,
  BankActionResponse
} from '../types/responses/bank-response';
import { apiFetcher, apiMutation } from '../utils/fetchers';

export const useGetBank = (gameCode?: string) => {
  const { data, error, isLoading } = useSWR<BankResponse>(
    gameCode ? `games/${gameCode}/bank` : null,
    apiFetcher
  );

  return { data, error, isLoading };
};

export const useGetBankItem = (gameCode: string, itemId: string) => {
  const { data, error, isLoading } = useSWR<BankItem>(
    `games/${gameCode}/bank/${itemId}`,
    apiFetcher,
    {
      suspense: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  return { data, error, isLoading };
};

export const useBankAction = (gameCode: string) => {
  const { data, error, isMutating, trigger } = useSWRMutation<
    BankActionResponse,
    Error,
    string,
    BankActionArgument & { itemId: string; action: 'acquire' | 'return' }
  >(
    'bank-action',
    (_, { arg }) =>
      apiMutation(`games/${gameCode}/bank/${arg.itemId}/${arg.action}`, {
        arg: {
          actor: arg.actor,
          actorId: arg.actorId,
          quantity: arg.quantity
        }
      }),
    {
      revalidate: false
    }
  );

  return { data, error, isMutating, trigger };
};
